//declare var moment: any;
declare var timepicker: any;
namespace Nobox {
    @Serenity.Decorators.element("<div/>")
    @Serenity.Decorators.registerEditor([Serenity.IStringValue, Serenity.IReadOnly])
    export class CustomFieldsDataEditor extends Serenity.Widget<any> {

        //private value: string;
        constructor(container: JQuery, options: ICustomFieldsDataEditorOptions) {
            super(container, options);
        }
        isNew: boolean = false;
        protected lblElm = `<label class="caption" for="forId">Data</label>`;
        protected inpElm = `<input id="inpId" name="inpName" type="text" class="editor" placeholder="inpPHolder"/>`;
        protected divElm = `<div id="inpId" class="editor s-Serenity-ImageUploadEditor s-ImageUploadEditor" placeholder="inpPHolder"></div>`;
        protected txtAreaElm = `<textarea id="inpId" name="inpName" class="" placeholder="inpPHolder"></textarea>`;
        protected tambahanElm = `<div class="vx"></div><div class="clear"></div>`;
        protected dataEdit = [] as Nobox.form[];

        isValidJSON(jsonString) {
            try {
                JSON.parse(jsonString);
                return true;
            } catch (error) {
                return false;
            }
        }

        async renderElm(list: Nobox.form[]) {
            this.element.parents("field").removeClass("field").addClass("fieldCustom")
            let frmData = this.element;
            let $this = this;
            frmData.html("");
            frmData.addClass("rowCustom row");
            frmData.parent().css("overflow-x", "hidden");
            //ambil dari setting def
            this.dataEdit = list;
            if (this.dataEdit.length <= 0) {
                let settingCustomFld = $("#customFldProductData").val();
                if (!Q.isEmptyOrNull(settingCustomFld) && this.isValidJSON(settingCustomFld)) {
                    this.dataEdit = JSON.parse($("#customFldProductData").val()) as Nobox.form[];
                } else {
                    let dCFld = null;
                    await Q.serviceCall({
                        blockUI: true,
                        url: "/Services/" + CustomFields.CustomfieldsService.baseUrl + "/Retrieve",
                        request: {
                            EntityId: this.options.Menu,
                        },
                        onSuccess: (res: Serenity.RetrieveResponse<CustomFields.CustomfieldsRow>) => {
                            dCFld = res.Entity.Data;
                        }
                    })
                    if (!Q.isEmptyOrNull(dCFld) && this.isValidJSON(dCFld)) {
                        this.dataEdit = JSON.parse(dCFld);
                    } else {
                        this.dataEdit = [];
                    }
                }
            } else {
                let listSetCustomField = [], dataFinal = [];
                let settingCustomFld = $("#customFldProductData").val();
                if (!Q.isEmptyOrNull(settingCustomFld) && this.isValidJSON(settingCustomFld)) {
                    listSetCustomField = JSON.parse($("#customFldProductData").val()) as Nobox.form[];
                } else {
                    let dCFld = null;
                    await Q.serviceCall({
                        blockUI: true,
                        url: "/Services/" + CustomFields.CustomfieldsService.baseUrl + "/Retrieve",
                        request: {
                            EntityId: this.options.Menu,
                        },
                        onSuccess: (res: Serenity.RetrieveResponse<CustomFields.CustomfieldsRow>) => {
                            dCFld = res.Entity.Data;
                        }
                    })
                    if (!Q.isEmptyOrNull(dCFld) && this.isValidJSON(dCFld)) {
                        listSetCustomField = JSON.parse(dCFld);
                    }
                }

                this.dataEdit.forEach((obj, i) => {
                    let index = listSetCustomField.findIndex(ind => ind.id == obj.id);
                    if (index != -1) {
                        let objPerubahan = listSetCustomField[index];
                        objPerubahan.value = obj.value;
                        dataFinal.push(objPerubahan);
                    }
                });
                listSetCustomField.forEach((obj, i) => {
                    if (dataFinal.findIndex(ind => ind.id == obj.id) == -1)
                        dataFinal.splice(i, 0, obj);
                })
                this.dataEdit = dataFinal;
            }

            if (this.dataEdit.length == 0) {
                this.element.closest('.category').toggle(false);
            }

            this.dataEdit.forEach((fy: Nobox.form, yz) => {
                if (fy.isShow) {
                    let set = fy.settings as Nobox.settingsForm;
                    var elm = `<div class="field field-${fy.id} col-md-6 col-sm-12">`;
                    let idField;
                    let editor;
                    switch (set.field) {
                        case "input":
                            idField = `${set.field}-${set.inputType}-${fy.id}`;
                            elm += this.lblElm.replace("Data", set.label).replace("forId", idField);
                            switch (set.inputType) {
                                case "text":
                                    elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new Serenity.StringEditor(this.element.find(`#${idField}`));
                                    //set value
                                    if (fy.value) {
                                        editor.value = fy.value;
                                    } else {
                                        if (set.defValue && this.isNew)
                                            editor.value = set.defValue;
                                    }
                                    //set required
                                    Serenity.EditorUtils.setRequired(editor, set.required as boolean);
                                    //update dataedit
                                    editor.change(() => {
                                        this.dataEdit[yz].value = editor.value;
                                    });
                                    break;
                                case "number":
                                    elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new Serenity.StringEditor(this.element.find(`#${idField}`));
                                    //set value
                                    if (fy.value) {
                                        editor.value = fy.value;
                                    } else {
                                        if (set.defValue && this.isNew)
                                            editor.value = set.defValue;
                                    }
                                    //set required
                                    Serenity.EditorUtils.setRequired(editor, set.required as boolean);
                                    //update dataedit
                                    editor.change(() => {
                                        this.dataEdit[yz].value = editor.value;
                                    });
                                    break;
                                case "email":
                                    elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new Serenity.EmailAddressEditor(this.element.find(`#${idField}`));
                                    //set value
                                    if (fy.value) {
                                        editor.value = fy.value;
                                    } else {
                                        if (set.defValue && this.isNew)
                                            editor.value = set.defValue;
                                    }
                                    //set required
                                    Serenity.EditorUtils.setRequired(editor, set.required as boolean);
                                    //update dataedit
                                    editor.change(() => {
                                        this.dataEdit[yz].value = editor.get_value();
                                    });
                                    break;
                                case "date":
                                    elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new CustomDatePickerEditor($(`#${idField}`), { timeZone: null });
                                    //set value
                                    if (fy.value) {
                                        editor.set_value(fy.value);
                                    } else {
                                        if (set.defValue && this.isNew)
                                            editor.set_value(moment().format($.cookie("formatdate")));
                                    }
                                    //set required
                                    Serenity.EditorUtils.setRequired(editor, set.required as boolean);
                                    //update dataedit
                                    editor.change(() => {
                                        this.dataEdit[yz].value = editor.get_value();
                                    });
                                    break;
                                case "time":
                                    elm += `<input id="${idField}" name="${idField}" type="text" placeholder="${set.placeHolder}" class="editor custom-timepicker-editor"/>`;
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new CustomTimePickerEditor($(`#${idField}`), { hideLabel: false, enable: true, containerClass: null, fromFrmRs: true });
                                    //set value
                                    if (fy.value) {
                                        editor.set_value(fy.value);
                                    } else {
                                        if (set.defValue && this.isNew)
                                            editor.set_value(moment().format("H:mm"));
                                    }
                                    //set required
                                    Serenity.EditorUtils.setRequired(editor, set.required as boolean);
                                    //update dataedit
                                    editor.change(() => {
                                        this.dataEdit[yz].value = editor.get_value();
                                    });
                                    break;
                                case "url":
                                    elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new Serenity.URLEditor(this.element.find(`#${idField}`));
                                    //set value
                                    if (fy.value) {
                                        editor.value = fy.value;
                                    } else {
                                        if (set.defValue && this.isNew)
                                            editor.value = set.defValue;
                                    }
                                    //set required
                                    Serenity.EditorUtils.setRequired(editor, set.required as boolean);
                                    //update dataedit
                                    editor.change(() => {
                                        this.dataEdit[yz].value = editor.get_value();
                                    });
                                    break;
                                case "checkbox":
                                    elm += "<div class='col p-0'>"
                                    set.selectOpsi.forEach(xy => {
                                        let cek = "";
                                        //set value
                                        if (fy.value != null) {
                                            if (fy.value.findIndex(pr => pr == xy.id) != -1) {
                                                cek = "checked";
                                            }
                                        } else if (xy.selected && this.isNew) {
                                            cek = "checked";
                                        }
                                        elm += `<div class="custom-control custom-checkbox mt-1 mr-2">
                                    <input type="checkbox" id="checkbox-${fy.id}-${xy.id}" value="${xy.id}" name="checkboxResult-${fy.id}" class="custom-control-input inpCheckbox" ${cek}>
                                    <label class="custom-control-label" for="checkbox-${fy.id}-${xy.id}">${xy.name}</label>
                                    </div>`
                                    })
                                    elm += `</div>${this.tambahanElm}</div>`;
                                    frmData.append(elm);

                                    //update dataedit
                                    this.element.find(`input[name='checkboxResult-${fy.id}']`).on("change", function () {
                                        var selectedValues = [];
                                        $this.element.find(`input[name="checkboxResult-${fy.id}"]:checkbox:checked`).each(function () {
                                            selectedValues.push($(this).val());
                                        });
                                        $this.dataEdit[yz].value = selectedValues;
                                    })
                                    break;
                                case "radio":
                                    elm += "<div class='col p-0'>"
                                    set.selectOpsi.forEach(xy => {
                                        let cek = "";
                                        //set value
                                        if (xy.id == fy.value) {
                                            cek = "checked";
                                        } else if (xy.selected && this.isNew) {
                                            cek = "checked";
                                        }
                                        elm += `<div class="custom-control custom-radio mt-1 mr-2">
                                    <input type="radio" id="radio-${fy.id}-${xy.id}" value="${xy.id}" name="radioResult-${fy.id}" class="custom-control-input inpRadio" ${cek}>
                                    <label class="custom-control-label" for="radio-${fy.id}-${xy.id}">${xy.name}</label>
                                    </div>`
                                    })
                                    elm += `</div>${this.tambahanElm}</div>`;
                                    frmData.append(elm);

                                    //update dataedit
                                    this.element.find(`input[name='radioResult-${fy.id}']`).on("change", function () {
                                        $this.dataEdit[yz].value = $(this).attr("value");
                                    })
                                    break;
                                case "file":
                                    elm += this.divElm.replace("inpId", idField);
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new Serenity.FileUploadEditor(this.element.find(`#${idField}`), { allowNonImage: true });
                                    let initFile = false;
                                    $(`#${idField}`).find("ul").on("DOMNodeInserted", function () {
                                        if (initFile == false) {
                                            initFile = true;
                                            $('ul li.file-item.file-image').each(function () {
                                                var elIMage = $(this).find(".thumb ");
                                                $(this).find(".thumb ").removeAttr("style");
                                                $(this).find(".thumb ").css("overflow", "hidden");
                                                var image = elIMage.attr("href");
                                                elIMage.html(`<img src="${image}" style = "height: 100%;width: auto;overflow: hidden;margin:auto;" >`);
                                            });
                                            initFile = false;
                                            $this.dataEdit[yz].value = JSON.stringify(editor.get_value());
                                        }
                                    });
                                    //set required
                                    Serenity.EditorUtils.setRequired(editor, set.required as boolean);
                                    //update dataedit
                                    if (!Q.isEmptyOrNull(fy.value)) {
                                        editor.value = JSON.parse(fy.value).Filename;
                                    }
                                    break;
                                case "fileMulti":
                                    elm += this.divElm.replace("inpId", idField);
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new Serenity.MultipleFileUploadEditor(this.element.find(`#${idField}`), { allowNonImage: true, });
                                    let initFiles = false;
                                    $(`#${idField}`).find("ul").css({
                                        "display": "flex",
                                        "gap": "5px"
                                    });
                                    $(`#${idField}`).find("ul").on("DOMNodeInserted", function () {
                                        if (initFiles == false) {
                                            initFiles = true;
                                            $('ul li.file-item.file-image').each(function () {
                                                var elIMage = $(this).find(".thumb ");
                                                $(this).find(".thumb ").removeAttr("style");
                                                $(this).find(".thumb ").css("overflow", "hidden");
                                                var image = elIMage.attr("href");
                                                elIMage.html(`<img src="${image}" style = "height: 100%;width: auto;overflow: hidden;margin:auto;" >`);
                                            });
                                            initFiles = false;
                                            $this.dataEdit[yz].value = JSON.stringify(editor.get_value());
                                        }
                                    });
                                    //set required
                                    Serenity.EditorUtils.setRequired(editor, set.required as boolean);
                                    //set value
                                    if (!Q.isEmptyOrNull(fy.value)) {
                                        editor.value = JSON.parse(fy.value);
                                    }
                                    break;
                            }
                            break;
                        case "textarea":
                            idField = `textarea-${fy.id}`;
                            elm += this.lblElm.replace("Data", set.label).replace("forId", idField);
                            elm += this.txtAreaElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                            elm += this.tambahanElm + `</div>`;
                            frmData.append(elm);
                            editor = new Serenity.TextAreaEditor(this.element.find(`#${idField}`), { rows: 3 });

                            //set value
                            if (fy.value) {
                                editor.value = fy.value;
                            } else {
                                if (set.defValue && this.isNew)
                                    editor.value = set.defValue;
                            }
                            //set required
                            Serenity.EditorUtils.setRequired(editor, set.required as boolean);
                            //update dataedit
                            editor.change(() => {
                                this.dataEdit[yz].value = editor.value;
                            });
                            break;
                        case "select":
                            idField = `select-${fy.id}`;
                            elm += this.lblElm.replace("Data", set.label).replace("forId", idField);
                            elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                            elm += this.tambahanElm + `</div>`;
                            frmData.append(elm);
                            editor = new FormCustomEditor(this.element.find(`#${idField}`));
                            //set pilihan
                            editor.setOpt(set.selectOpsi)
                            //set required
                            Serenity.EditorUtils.setRequired(editor, set.required as boolean);
                            //set value
                            if (fy.value) {
                                editor.set_value(fy.value);
                            } else if (this.isNew){
                                let listSelectOpsi = set.selectOpsi.filter(vx => vx.selected);
                                if (listSelectOpsi.length > 0)
                                    editor.set_value(listSelectOpsi[0].id);
                            }
                            //update dataedit
                            editor.change(() => {
                                this.dataEdit[yz].value = editor.get_value();
                            });
                            break;
                        case "select-multi":
                            idField = `selectMulti-${fy.id}`;
                            elm += this.lblElm.replace("Data", set.label).replace("forId", idField);
                            elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                            elm += this.tambahanElm + `</div>`;
                            frmData.append(elm);
                            editor = new FormMultiCustomEditor(this.element.find(`#${idField}`));
                            //set pilihan
                            editor.setOpt(set.selectOpsi)
                            //set required
                            Serenity.EditorUtils.setRequired(editor, set.required as boolean);
                            //set value
                            if (fy.value) {
                                editor.set_value(fy.value);
                            } else if (this.isNew){
                                let listSelectOpsi = [];
                                set.selectOpsi.forEach(obj => {
                                    if (obj.selected)
                                        listSelectOpsi.push(obj.id);
                                });
                                editor.set_value(listSelectOpsi.toString());
                            }

                            //update dataedit
                            editor.change(() => {
                                this.dataEdit[yz].value = editor.get_value();
                            });
                            break;
                    }
                }
            });
        }

        get_value(): Nobox.form[] {
            return this.dataEdit;
        }

        get value(): Nobox.form[] {
            return this.get_value();
        }

        set_value(value: Nobox.form[]) {
            this.renderElm(value)
        }

        set value(v: Nobox.form[]) {
            this.set_value(v);
        }
    }

    export interface ICustomFieldsDataEditorOptions {
        Menu: CustomFieldsDataEnum
    }

    export enum CustomFieldsDataEnum {
        Contact = 1,
        Product = 2
    }
}